import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-2xl font-serif font-bold text-gray-800">
              Restoration by Design
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-base font-medium transition-colors ${
                isActive('/') ? 'text-rose-400' : 'text-gray-700 hover:text-rose-400'
              }`}
            >
              About
            </Link>
            <Link
              to="/furniture"
              className={`text-base font-medium transition-colors ${
                isActive('/furniture') ? 'text-rose-400' : 'text-gray-700 hover:text-rose-400'
              }`}
            >
              Furniture
            </Link>
            <Link
              to="/contact"
              className={`text-base font-medium transition-colors ${
                isActive('/contact') ? 'text-rose-400' : 'text-gray-700 hover:text-rose-400'
              }`}
            >
              Contact Us
            </Link>
            <a
              href="tel:9056081876"
              className="flex items-center space-x-2 text-gray-700 hover:text-rose-400 transition-colors"
            >
              <Phone className="h-4 w-4" />
              <span className="font-medium">(905) 608-1876</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className={`text-base font-medium ${
                  isActive('/') ? 'text-rose-400' : 'text-gray-700'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/furniture"
                className={`text-base font-medium ${
                  isActive('/furniture') ? 'text-rose-400' : 'text-gray-700'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Furniture
              </Link>
              <Link
                to="/contact"
                className={`text-base font-medium ${
                  isActive('/contact') ? 'text-rose-400' : 'text-gray-700'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact Us
              </Link>
              <a
                href="tel:9056081876"
                className="flex items-center space-x-2 text-gray-700"
              >
                <Phone className="h-4 w-4" />
                <span className="font-medium">(905) 608-1876</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
